import React from 'react';

/**
 * Boolean 상태 관리 시 필요한 헬퍼 콜백도 같이 만듭니다.
 *
 * NOTE: usehooks-ts 코드 리팩토링 버전.
 */
export const useBoolean = (defaultValue?: boolean) => {
  const [value, setValue] = React.useState(!!defaultValue);
  const helpers = React.useMemo(() => {
    return {
      setTrue: () => setValue(true),
      setFalse: () => setValue(false),
      toggle: () => setValue(x => !x),
    };
  }, []);
  return { value, setValue, ...helpers };
};
